<template>
    <div class="background">
        <div>
            <el-row >
                <el-col :span="14" :offset="5">
                    <Top/>
                </el-col>
            </el-row>
            <el-row class="row-main">
                <el-col :span="3" :offset="5" class="col-main">
                    <div class="div-main">
                        <Aside/>
                    </div>
                </el-col>
                <el-col :span="11" class="col-main">
                    <div class="div-main">
                        <h3>永安头条</h3>
                        <div>
                            <div v-for="(item,index) in list" :key="index" class="newsItem">
                                <el-link @click="showDrawer(index)">{{index +1}}. {{item.news_title}}</el-link>
                            </div>
                        </div>
                        <el-drawer :title="news_title" size="66.7%" :visible.sync="drawer">
                            <div class="drawer">
                                <div v-html="news_detail"></div>
                            </div>
                        </el-drawer>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Footer/>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import Top from './Top';
import Aside from './Aside';
import Footer from './Footer';
export default {
    name : 'HotNews',
    data() {
        return {
            list : [],
            drawer : false,
            news_title : "",
            news_detail : ""
        }
    },
    components: {
        'Top' : Top,
        'Aside' : Aside,
        'Footer' : Footer
    },
    mounted () {
        const _this = this;
        var hotNewsList;
        this.$axios
            .get('../static/json/hotNewsList.json')
            .then(response => (
                hotNewsList = response.data.data,
                this.list = hotNewsList
            ));
    },
    methods: {
        showDrawer(index){
            
            this.drawer = true;
            this.news_title = this.list[index].news_title,
            this.news_detail = this.list[index].news_detail
        }
    }
}
</script>
<style lang="scss" scoped>
/** 主组件DIV背景,高度铺满页面主DIV */
.background{
    height: 100%;
    // background: url('https://bing.biturl.top/?resolution=1920&format=image&index=0&mkt=zh-CN');
}
.background>div{
    background-color:  rgba(255, 255, 255, 0.5);
    height: 100%;
}
/deep/ .el-drawer__header span:focus {
    outline: 0;
}
/deep/ .el-drawer{
    overflow: scroll
}
.el-link{
    font-size: 20px;
}
.newsItem .el-link{
    line-height: 50px;
}
.row-main{
    height: 80%;
    margin: 10px auto;
}
.col-main,.div-main{
    height: 100%;
}
.div-main{
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
    background-color:  rgba(255, 255, 255, 0.9);
    border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/HotNews.vue